import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  BuyerSignalStatsQuery,
  BuyerSignalStatsQueryVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const buyerSignalStatsQuery = graphql(`
  query buyerSignalStats($request: BuyerSignalStatsRequest!) {
    buyerSignalStats(BuyerSignalStatsRequest: $request) {
      signalStats {
        buyerGuid
        buyerName
        noticeCount
      }
      totalCount
    }
  }
`);

export type BuyerSignalStatsRequest = BuyerSignalStatsQueryVariables["request"];
export type BuyerSignalStatsData = BuyerSignalStatsQuery["buyerSignalStats"];

/**
 * Per-buyer stats over a bounded candidate set (e.g. a framework's buyers). The signals field is
 * deliberately not selected here: computing it is the expensive part and the consuming tables only
 * need the filtered/ordered rows — exports request signals server-side instead.
 */
export function useBuyerSignalStats(
  request: BuyerSignalStatsRequest,
  options?: UseQueryOptions<BuyerSignalStatsQuery, unknown, BuyerSignalStatsQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery<BuyerSignalStatsQuery>(
    ["buyerSignalStats", request],
    buyerSignalStatsQuery,
    [{ request }],
    options,
  );

  return { data: data?.buyerSignalStats, ...rest };
}
